/* ARTMiE LP — spoločné správanie pre VŠETKY LP sekcie (generované _migrate-inline-to-common.js)
   Perks marquee: auto-scroll SPEED 0.3 + drag myšou + swipe prstom, pauza pri hoveri.
   POZN.: externý súbor nemá document.currentScript kontext sekcie → inicializuje každý .lp-hero__perks na stránke. */
(function () {
  var SPEED = 0.3;

  function initPerks(box) {
    var track = box.querySelector('.lp-perks-track');
    if (!track || box.dataset.perksDrag) return;
    box.dataset.perksDrag = '1';
    box.classList.add('lp-perks--drag');

    var half = 0, pos = 0;
    function measure() { var w = track.scrollWidth / 2; if (w > 0) half = w; }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    [300, 900, 2000].forEach(function (ms) { setTimeout(measure, ms); });
    if (window.ResizeObserver) { try { new ResizeObserver(measure).observe(track); } catch (e) {} }

    var paused = false, dragging = false, startX = 0, startScroll = 0, resumeT = null;
    // rAF beží stále (nikdy sa nezasekne), ale zápis do layoutu robí LEN keď je pás v obraze
    var onScreen = true;
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    function tick() {
      if (!half) measure();
      if (onScreen && !reduce && !paused && !dragging && half) { pos += SPEED; if (pos >= half) pos -= half; box.scrollLeft = pos; }
      requestAnimationFrame(tick);
    }
    if (window.IntersectionObserver) {
      try { new IntersectionObserver(function (es) { onScreen = es[es.length - 1].isIntersecting; }).observe(box); } catch (e) {}
    }
    requestAnimationFrame(tick);

    box.addEventListener('mouseenter', function () { paused = true; });
    box.addEventListener('mouseleave', function () { if (!dragging) paused = false; });
    box.addEventListener('mousedown', function (e) { dragging = true; paused = true; startX = e.pageX; startScroll = box.scrollLeft; box.classList.add('is-grabbing'); e.preventDefault(); });
    window.addEventListener('mousemove', function (e) { if (!dragging) return; var x = startScroll - (e.pageX - startX); if (half) { if (x >= half) x -= half; else if (x < 0) x += half; } box.scrollLeft = x; });
    window.addEventListener('mouseup', function () { if (!dragging) return; dragging = false; box.classList.remove('is-grabbing'); pos = box.scrollLeft; paused = box.matches(':hover'); });
    box.addEventListener('touchstart', function () { paused = true; if (resumeT) clearTimeout(resumeT); }, { passive: true });
    box.addEventListener('touchend', function () { resumeT = setTimeout(function () { pos = box.scrollLeft; paused = false; }, 1500); }, { passive: true });
  }

  function boot() {
    var boxes = document.querySelectorAll('.lp-hero__perks');
    for (var i = 0; i < boxes.length; i++) initPerks(boxes[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();


/* == LP doba dodania — generický, jazyk cez data-t-* na wrapperi; variant-aware (bundle/swatch) + quantity-aware == */
(function(){
  var wrap=document.querySelector('[data-lp-delivery]'); if(!wrap) return;
  var EL=document.getElementById('lp-variant-delivery'); if(!EL) return;
  function A(n){return wrap.getAttribute(n)||'';}
  var SUP=A('data-t-sup'),PRO=A('data-t-pro'),PRE=A('data-t-pre'),UNIT=A('data-t-unit'),SAME=A('data-t-same'),SPLIT=A('data-t-split');
  var CHIP='lp-delivery__chip';
  function numTxt(s){return String(s).replace(/[^0-9]/g,'');}
  var qtyInput=document.getElementById('lp-qty-input');
  function cq(){var n=qtyInput?parseInt(qtyInput.value,10):1;return(!n||n<1)?1:n;}
  var cur={dmin:A('data-dmin'),dmax:A('data-dmax'),dsrc:A('data-dsrc'),fast:parseInt(A('data-fast'),10)||0};
  function setState(ext){wrap.classList.toggle('lp-delivery--ext',ext);wrap.classList.toggle('lp-delivery--fast',!ext);}
  function render(){
    var dmin=cur.dmin,dmax=cur.dmax,dsrc=cur.dsrc,fast=cur.fast||0,qty=cq(),h,ext;
    if(!dmin||!dmax){h=SAME;ext=false;}
    else{var b='';if(dsrc==='supplier')b='<span class="'+CHIP+'">'+SUP+'</span>';else if(dsrc==='production')b='<span class="'+CHIP+'">'+PRO+'</span>';
      if(fast>0&&qty<=fast){h=SAME;ext=false;}
      else if(fast>0&&qty>fast){h=b+SPLIT.replace('{f}',fast).replace('{r}',(qty-fast)).replace('{min}',numTxt(dmin)).replace('{max}',numTxt(dmax));ext=true;}
      else{h=b+PRE+' '+numTxt(dmin)+'–'+numTxt(dmax)+' '+UNIT;ext=true;}}
    EL.innerHTML=h;setState(ext);
  }
  function fromBtn(btn){if(!btn)return;var dm=btn.getAttribute('data-dmin');if(dm===null)return;cur={dmin:dm,dmax:btn.getAttribute('data-dmax'),dsrc:btn.getAttribute('data-dsrc'),fast:parseInt(btn.getAttribute('data-fast'),10)||0};render();}
  Array.prototype.forEach.call(document.querySelectorAll('[data-vid][data-dmin]'),function(b){b.addEventListener('click',function(){fromBtn(b);});});
  var minus=document.getElementById('lp-qty-minus'),plus=document.getElementById('lp-qty-plus');
  if(minus)minus.addEventListener('click',function(){setTimeout(render,30);});
  if(plus)plus.addEventListener('click',function(){setTimeout(render,30);});
  if(qtyInput){qtyInput.addEventListener('input',render);qtyInput.addEventListener('change',render);}
  // plátno (canvas) — výber rozmeru cez #lp-size-grid, delivery dáta v #lp-variant-data
  var vmap=null; try{ var _j=document.getElementById("lp-variant-data"); if(_j){ vmap={}; JSON.parse(_j.textContent||"[]").forEach(function(x){ vmap[String(x.id)]={dmin:(x.dmin==null?"":String(x.dmin)),dmax:(x.dmax==null?"":String(x.dmax)),dsrc:(x.dsrc==null?"":x.dsrc),fast:parseInt(x.fast,10)||0}; }); } }catch(e){}
  var vidInput=document.getElementById("lp-variant-id");
  function fromVid(){ if(!vmap||!vidInput)return; var d=vmap[String(vidInput.value)]; if(d){ cur={dmin:d.dmin,dmax:d.dmax,dsrc:d.dsrc,fast:d.fast||0}; render(); } }
  var grid=document.getElementById("lp-size-grid");
  /* lp-delivery-sync: rozmer sa vyberá mriežkou (desktop) aj kolieskom #lp-wheel (mobil).
     Koliesko sa mriežky nedotkne, preto nesledujeme kliky, ale text vybraného rozmeru —
     ten prepisuje selectVariant() pri každej ceste výberu. */
  if(grid&&vmap&&vidInput){
    var mark=document.getElementById("lp-sticky-size")||document.getElementById("lp-selected-label");
    if(mark&&window.MutationObserver){ try{ new MutationObserver(function(){ fromVid(); }).observe(mark,{childList:true,characterData:true,subtree:true}); }catch(e){} }
    if(grid) grid.addEventListener("click",function(){ setTimeout(fromVid,60); });
    if(vidInput.value) fromVid();
  }
  var act=document.querySelector('[data-vid][data-dmin].lp-bundle--active,[data-vid][data-dmin].lp-swatch--active');
  if(act)fromBtn(act); else render();
})();


/* == LP galéria — odložené sťahovanie fotiek (LCP) ==
   Neaktívne fotky v .lp-stage majú data-src/data-srcset; loading="lazy" na ne neúčinkuje,
   lebo všetky ležia naskladané v prvom výreze. Sťahujeme aktívnu + susedné hneď,
   zvyšok až po load (aby prepínanie ostalo okamžité). */
(function () {
  var stage = document.getElementById('lp-stage');
  if (!stage) return;
  var imgs = Array.prototype.slice.call(stage.querySelectorAll('.lp-stage__img'));
  if (!imgs.length) return;

  function hydrate(im) {
    if (!im || !im.getAttribute('data-src')) return;
    var ss = im.getAttribute('data-srcset');
    if (ss) { im.setAttribute('srcset', ss); im.removeAttribute('data-srcset'); }
    im.setAttribute('src', im.getAttribute('data-src'));
    im.removeAttribute('data-src');
  }
  function around() {
    var i = -1;
    for (var k = 0; k < imgs.length; k++) if (imgs[k].className.indexOf('active') >= 0) { i = k; break; }
    if (i < 0) i = 0;
    hydrate(imgs[i]); hydrate(imgs[i + 1]); hydrate(imgs[i - 1]);
  }
  function all() { for (var k = 0; k < imgs.length; k++) hydrate(imgs[k]); }

  around();
  if (window.MutationObserver) {
    try { new MutationObserver(around).observe(stage, { subtree: true, attributes: true, attributeFilter: ['class'] }); } catch (e) {}
  }
  var thumbs = document.getElementById('lp-thumbs');
  if (thumbs) thumbs.addEventListener('pointerenter', all, { once: true });
  stage.addEventListener('pointerdown', all, { once: true, passive: true });
  if (document.readyState === 'complete') setTimeout(all, 1200);
  else window.addEventListener('load', function () { setTimeout(all, 1200); });
})();
